export default __webpack_public_path__ + "static/img-sentiment-analysis-cc0323e225668db6660f856c168d6273.png";